import {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import ProjectEditionNav from 'App/layout/components/projectEditionNav';
import {PROPORTIONS} from 'App/layout/layoutConstants';
import {selectLayoutType} from 'App/layout/layoutSlice';

type TProps = {
  reparentableContent: ReactElement;
  reparentableMap: ReactElement;
};
const ProjectEditionTemplate = ({
  reparentableContent,
  reparentableMap,
}: TProps): ReactElement => {
  const layoutType = useSelector(selectLayoutType);

  return (
    <div className="flex h-screen flex-col">
      <ProjectEditionNav />
      <div
        className={twMerge(
          'w-100vw grid grow overflow-hidden',
          PROPORTIONS[layoutType],
        )}
      >
        <div className="overflow-auto">{reparentableContent}</div>
        <div className="overflow-hidden border-l border-gray-300">
          {reparentableMap}
        </div>
      </div>
    </div>
  );
};

export default ProjectEditionTemplate;
